import React from "react";
import "./transactiontable.css";

export default function AddTransactionModal({
  showAddModal,
  setShowAddModal,
  activeForm,
  setActiveForm,
  formData,
  setFormData,
  nlpInput,
  setNlpInput,
  handleAddTransaction,
}) {
  if (!showAddModal) return null;

  // === FUNGSI NLP PARSING ===
  const parseNLPInput = (text) => {
    const lines = text.split("\n").filter((line) => line.trim() !== "");
    const parsedTransactions = [];

    lines.forEach((line) => {
      // Pisahkan teks dan angka, contoh: "kopi kenangan Rp50.000"
      const match = line.match(/(.+?)\s*(?:Rp\s*)?([\d.,]+)/i);
      if (match) {
        const description = match[1].trim();
        const nominal = match[2]
          .replace(/[^\d,.-]/g, "") // hanya angka, koma, titik
          .replace(/\./g, "") // hapus titik ribuan
          .replace(",", "."); // ubah koma ke titik

        parsedTransactions.push({
          'description': description,
          'nominal': parseFloat(nominal),
        });
      }
    });
    return parsedTransactions;
  };

  // === HANDLE SIMPAN ===
  const handleSave = async () => {
    if (activeForm === "nlp") {
      const transactions = parseNLPInput(nlpInput);
      if (!transactions.length) {
        alert("Format salah.");
        return;
      }

      for (const trx of transactions) {
        await handleAddTransaction(trx);
      }
    } else {
      if (!formData.description || !formData.nominal || !formData.category_1 || !formData.category_2) {
        alert("Semua field wajib diisi");
        return;
      }
      await handleAddTransaction(formData);
    }

    setFormData({ description: "", nominal: "", category_1: "", category_2: "" });
    setNlpInput("");
    setShowAddModal(false);
  };

  return (
    <div className="edit-modal">
      <div className="edit-modal-content wide">
        <h3>Tambah Transaksi</h3>

        {/* Tombol Toggle */}
        <div className="form-toggle">
          <button
            className={activeForm === "nlp" ? "active" : ""}
            onClick={() => setActiveForm("nlp")}
          >
            NLP
          </button>
          <button
            className={activeForm === "manual" ? "active" : ""}
            onClick={() => setActiveForm("manual")}
          >
            Isi Manual
          </button>
        </div>

        {/* FORM NLP */}
        {activeForm === "nlp" ? (
          <div className="nlp-form">
            <label>Deskripsi</label>
            <textarea
              rows="3"
              placeholder="Contoh: kopi kenangan Rp50.000"
              value={nlpInput}
              onChange={(e) => setNlpInput(e.target.value)}
            />
            <p
              style={{
                textAlign: "left",
                fontSize: "12px",
                color: "#777",
                marginTop: "-5px",
              }}
            >
              Pisahkan dengan Enter untuk lebih dari 1 transaksi
            </p>
          </div>
        ) : (
          /* FORM MANUAL */
          <div className="manual-form">
            <label>Deskripsi</label>
            <input
              type="text"
              placeholder="Masukan Deskripsi..."
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />

            <label>Nominal</label>
            <input
              type="number"
              placeholder="Masukkan nominal..."
              value={formData.nominal}
              onChange={(e) =>
                setFormData({ ...formData, nominal: e.target.value })
              }
            />

            <label>Kategori Pengeluaran</label>
            <select
              value={formData.category_1}
              onChange={(e) =>
                setFormData({ ...formData, category_1: e.target.value })
              }
            >
              <option value="">Pilih kategori...</option>
              <option value="Makanan & Kebutuhan Rumah Tangga">Makanan & Kebutuhan Rumah Tangga</option>
              <option value="Transportasi">Transportasi</option>
              <option value="Konektivitas">Konektivitas</option>
              <option value="Hiburan">Hiburan</option>
              <option value="Tagihan dan Lainnya">Tagihan dan Lainnya</option>
            </select>

            <label>Jenis Kebutuhan</label>
            <select
              value={formData.category_2}
              onChange={(e) =>
                setFormData({ ...formData, category_2: e.target.value })
              }
            >
              <option value="">Pilih jenis kebutuhan...</option>
              <option value="Primer">Primer</option>
              <option value="Sekunder">Sekunder</option>
              <option value="Tersier">Tersier</option>
            </select>
          </div>
        )}

        <div className="edit-modal-actions right">
          <button className="save-btn" onClick={handleSave}>
            Simpan
          </button>
          <button className="cancel-btn" onClick={() => setShowAddModal(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}